export const Colors = {
    background: '#15151c',
    border: '#303030',
    text: 'rgba(255, 255, 255, 0.85)',
    cardBackground: 'rgb(48, 50, 69)',
    cardBackgroundHover: 'rgb(56, 59, 82)',
    cardBackgroundActive: 'rgb(64, 68, 94)',
    cardBorder: '#7a7d99',
}